// @ts-nocheck
if (!customElements.get("video-player")) {
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();
      this.isPlaying = this.hasAttribute("data-autoplay");
    }

    connectedCallback() {
      this.video = this.querySelector("video");
      this.playBtn = this.querySelector(".play-btn");
      this.pauseBtn = this.querySelector(".pause-btn");
      const audioButtons = this.querySelector(".audio-buttons");
      this.muteBtn = audioButtons
        ? audioButtons.querySelector(".audio-button.mute")
        : null;
      this.playAudioBtn = audioButtons
        ? audioButtons.querySelector(".audio-button.play")
        : null;

      this.updateButtonVisibility();
      this.updateMuteButtonVisibility();

      this.video.addEventListener("click", () => this.togglePlay());
      this.playBtn.addEventListener("click", () => this.togglePlay());
      this.pauseBtn.addEventListener("click", () => this.togglePlay());
      this.video.addEventListener("ended", () => {
        this.isPlaying = false;
        this.updateButtonVisibility();
      });

      if (this.muteBtn) {
        this.muteBtn.addEventListener("click", () => this.toggleMute());
      }
      if (this.playAudioBtn) {
        this.playAudioBtn.addEventListener("click", () => this.toggleMute());
      }
    }

    togglePlay() {
      this.isPlaying = !this.isPlaying;
      this.video[this.isPlaying ? "play" : "pause"]();
      this.updateButtonVisibility();
    }

    toggleMute() {
      const wasUnmuting = this.video.muted;
      this.video.muted = !this.video.muted;

      // If unmuting this video, mute all other videos on the page
      if (wasUnmuting) {
        this.muteOtherVideos();
      }

      this.updateMuteButtonVisibility();
    }

    muteOtherVideos() {
      // Get all video-player elements on the page
      const allVideoPlayers = document.querySelectorAll("video-player");

      allVideoPlayers.forEach((player) => {
        // Skip this current player
        if (player === this) return;

        // Mute the video
        const video = player.querySelector("video");
        if (video && !video.muted) {
          video.muted = true;
          // Update the buttons for the muted player
          if (player.updateMuteButtonVisibility) {
            player.updateMuteButtonVisibility();
          }
        }
      });
    }

    updateMuteButtonVisibility() {
      if (!this.muteBtn || !this.playAudioBtn) return;

      if (this.video.muted) {
        this.muteBtn.style.display = "block";
        this.playAudioBtn.style.display = "none";
      } else {
        this.muteBtn.style.display = "none";
        this.playAudioBtn.style.display = "block";
      }
    }

    updateButtonVisibility() {
      if (this.isPlaying) {
        this.playBtn.style.display = "none";
        this.pauseBtn.style.display = "flex";
      } else {
        this.playBtn.style.display = "flex";
        this.pauseBtn.style.display = "none";
      }
    }
  }

  customElements.define("video-player", VideoPlayer);
}
